import React, { useState, useRef } from "react";
import { Form, Input, Button, message, Space, Radio } from "antd";
import {
  UserOutlined,
  LockOutlined,
  SafetyCertificateOutlined,
  FileMarkdownOutlined,
} from "@ant-design/icons";
import httpUtil from "../../../utils/httpUtil";

export const Register = () => {
  // 配置message全局样式
  message.config({
    top: 100,
    duration: 2,
    maxCount: 3,
  });

  const [form] = Form.useForm(); // 获取form实例
  const [loading, setLoading] = useState(false);


  const onFinish = (values) => {
    const { userName, password, full_name, role } = values;
    const data = { userName, password, full_name, role };

    // 显示正在登录中的消息
    let hideLoading = message.loading('正在注册中...', 0);
    setLoading(true)

    form.resetFields(); // 清空所有表单字段
    httpUtil.register(data).then((res) => {
      hideLoading();
      setLoading(false)
      if (res.success) {message.success("注册成功！");}else{
        message.error(res.error)
      }
    });
  };

  return (
    <Form
      form={form} // 将form实例绑定到Form组件
      name="normal_login"
      className="login-form"
      initialValues={{
        role: "学生",
      }}
      onFinish={onFinish}
    >
      <Form.Item
        name="full_name"
        rules={[
          {
            required: true,
            message: "请输入您的姓名",
          },
        ]}
      >
        <Input
          prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder="请输入您的姓名！"
        />
      </Form.Item>

      <Form.Item
        name="userName"
        rules={[
          {
            required: true,
            message: "请输入您的账号!",
          },
        ]}
      >
        <Input
          prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder="请使用学号/教师号注册"
        />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: "请输入您的密码!",
          },
        ]}
      >
        <Input
          prefix={<LockOutlined className="site-form-item-icon" />}
          type="password"
          placeholder="密码"
        />
      </Form.Item>

      <Form.Item
        name="rePassword"
        dependencies={["password"]}
        hasFeedback
        rules={[
          {
            required: true,
            message: "请确认您的密码!",
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error("您输入的两次密码不匹配!"));
            },
          }),
        ]}
      >
        <Input.Password
          prefix={<LockOutlined className="site-form-item-icon" />}
          type="password"
          placeholder="确认密码"
        />
      </Form.Item>

      <Form.Item name={"role"} noStyle>
        <Radio.Group disabled={loading}>
          <Space>
            <Radio value={"学生"}>学生</Radio>
            <Radio value={"教师"}>教师</Radio>
            <Radio value={"辅导员"}>辅导员</Radio>
          </Space>
        </Radio.Group>
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{ width: "100%", marginTop: 20 }}
          loading={loading}
        >
          注册
        </Button>
      </Form.Item>

      <div
        className="marked"
        style={{
          width: "80%",
          margin: "0 auto 10px",
          height: 12,
          borderBottom: "1px solid #ddd",
          textAlign: "center",
        }}
      >
        <span
          className="words"
          style={{
            background: "white",
            paddingLeft: 8,
            paddingRight: 8,
            display: "inline-block",
          }}
        >
          请记住您的账号和密码
        </span>
      </div>
    </Form>
  );
};
